<template>
  <div class="content-container">
    <div class="search-row">
      <div class="section-box">
        <div class="das-form-container">
          <div class="das-form-group">
            <div class="das-form-row" style="margin-top: 0">
              <div class="das-form-col col-4">
                <div class="das-form-input">
                  <div class="label">
                    {{ $t('config.account.assign.field.txn') }}
                  </div>
                  <div class="child-w-80">
                    <Treeselect
                      v-model="treeValue"
                      :multiple="false"
                      :close-on-select="true"
                      :searchable="true"
                      :options="optionsTree"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="grid-scroll mb-20">
      <div class="das-form-container full-h">
        <div class="das-form-group full-h">
          <div class="das-form-row m-0 full-h">
            <div class="das-form-col col-4" style="height: calc(100%)">
              <GridVx
                ref="agGridLeft"
                v-loading="tableLeftLoading"
                :columns="tableLeftColumns"
                :rows="tableLeftRows"
                :auto-size-cell="true"
                :auto-select-first-row="true"
                class="agGrid"
                @selectionChanged="fnGetBusinessDistrictByTxn"
              />
              <!-- <GridPagingMini
                target="agGrid"
                :total-size="pageParams.totalPage"
                :page-num="pageParams.pageNum"
                @pageChanged="onPageChanged"
                @onPageSizeChange="onPageSizeChange"
              /> -->
            </div>

            <div class="das-form-col full-h col-8 datnt">
              <GridVx
                ref="agGridRight"
                v-loading="tableRightLoading"
                :columns="tableRightColumns"
                :rows="tableRightRows"
                :auto-size-cell="true"
                class="agGrid"
                @selectionChanged="onSelectRow"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="button-containers" style="margin-top: auto">
      <button
        class="btn primary small"
        @click="
          fnGetBusinessDistrictWithDefaultTxn()
          dialogDefaultTxnVisible = true
        "
      >
        {{ $t('config.account.assign.btn.btn1') }}
      </button>
      <button class="btn primary small" @click="dialogFeeVisible = true">
        {{ $t('config.account.assign.btn.btn2') }}
      </button>
      <button class="btn primary small" @click="dialogProductVisible = true">
        {{ $t('config.account.assign.btn.btn3') }}
      </button>
      <button
        class="btn primary small outline"
        :disabled="deleteDisabled"
        @click="fnDeleteConfig"
      >
        {{ $t('config.account.assign.btn.btn4') }}
      </button>
    </div>

    <!-- Assign default txn to business district -->
    <el-dialog
      :title="$t('config.account.assign.title.dialog1')"
      :visible.sync="dialogDefaultTxnVisible"
      width="70%"
      :close-on-click-modal="false"
      @close="
        defaultTxnRows = []
        dialogDefaultTxnVisible = false
      "
    >
      <div class="das-form-container">
        <div class="das-form-title-container">
          <div class="das-form-title">
            <div class="main-title">
              {{
                $t('config.account.assign.title.sub1_1', {
                  txn: `(${txnSelected?.transaction_id} - ${txnSelected?.sub_transaction_id} - ${txnSelected?.sub_transaction_desc})`
                })
              }}
            </div>
          </div>
        </div>
        <div class="grid-scroll mb-20">
          <GridVx
            ref="agGrid"
            class="agGrid"
            :columns="defaultTxnCols"
            :rows="defaultTxnRows"
            :auto-size-cell="true"
            :context="context"
          />
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="
              // reset defaultTxnRows
              defaultTxnRows = []
              dialogDefaultTxnVisible = false
            "
          >
            {{ $t('config.account.assign.btn.close') }}
          </button>
          <button class="btn primary small" @click="fnAssignDefaultTxn">
            {{ $t('config.account.assign.btn.submit') }}
          </button>
        </div>
      </span>
    </el-dialog>

    <!-- Assign default txn to business district -->
    <el-dialog
      :title="$t('config.account.assign.title.dialog2')"
      :visible.sync="dialogFeeVisible"
      width="40%"
      :close-on-click-modal="false"
      @close="
        shiftBusinessForm = { ...defaultShiftBusinessForm }
        dialogFeeVisible = false
      "
    >
      <div class="das-form-container">
        <div class="das-form-title-container">
          <div class="das-form-title">
            <div class="main-title">
              {{
                $t('config.account.assign.title.sub2_1', {
                  txn: `(${txnSelected?.transaction_id} - ${txnSelected?.sub_transaction_id} - ${txnSelected?.sub_transaction_desc})`
                })
              }}
            </div>
          </div>
        </div>

        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-12">
              <div class="das-form-input">
                <div class="label required">
                  {{ $t('config.account.assign.field.business') }}
                </div>
                <div class="">
                  <select-with-search-table
                    style="width: 100%"
                    index-field="business_district_id"
                    :search-fields="[
                      'business_district_id',
                      'business_district_code',
                      'business_district_name'
                    ]"
                    :selected-index-field-value="
                      shiftBusinessForm.business_district_id
                    "
                    :value="shiftBusinessForm.business_district_id"
                    :rows="shiftBusinessRows"
                    :columns="shiftBusinessCols"
                    :dropdown-width="600"
                    :is-remove-btn="true"
                    @selectionChanged="onSelectShiftBusiness"
                  >
                    <template v-slot:value="{ selectedValue: selectedData }">
                      <div>
                        <span>
                          {{
                            `${selectedData?.business_district_code || ''} - ${
                              selectedData?.business_district_name || ''
                            }`
                          }}
                        </span>
                      </div>
                    </template>
                  </select-with-search-table>
                </div>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-12">
              <div class="das-form-input">
                <div class="label">
                  <div class="checkbox-wrap">
                    <input
                      id="isShift"
                      v-model="shiftBusinessForm.is_shift"
                      type="checkbox"
                      :disabled="isRoomAssignedWithShift"
                    />
                    <label
                      for="isShift"
                      style="color: #606266; font-size: 14px"
                      >{{ $t('config.account.assign.field.isShift') }}</label
                    >
                  </div>
                </div>
                <div class="">
                  <select-with-search-table
                    style="width: 100%"
                    index-field="id"
                    :search-fields="['id', 'name']"
                    :selected-index-field-value="shiftBusinessForm.shift_id"
                    :value="shiftBusinessForm.shift_id"
                    :rows="shiftRows"
                    :columns="shiftCols"
                    :dropdown-width="400"
                    :is-remove-btn="true"
                    :disabled="!shiftBusinessForm.is_shift"
                    @selectionChanged="onSelectShift"
                  >
                    <template v-slot:value="{ selectedValue: selectedData }">
                      <div>
                        <span>
                          {{
                            `${selectedData?.id || ''} - ${
                              selectedData?.name || ''
                            }`
                          }}
                        </span>
                      </div>
                    </template>
                  </select-with-search-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="
              shiftBusinessForm = { ...defaultShiftBusinessForm }
              dialogFeeVisible = false
            "
          >
            {{ $t('config.account.assign.btn.close') }}
          </button>
          <button
            class="btn primary small"
            :disabled="isRoomAssigned && !isRoomAssignedWithShift"
            @click="onAssignRoom"
          >
            {{ $t('config.account.assign.btn.submit') }}
          </button>
        </div>
      </span>
    </el-dialog>

    <assign-transaction-product-dialog
      v-model="dialogProductVisible"
      :txn-selected="txnSelected"
      @resetQuery="onReset"
    />
  </div>
</template>

<script>
/* eslint-disable */
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import Treeselect from '@riophae/vue-treeselect'
import CellRenderCheckbox from './components/CellRenderCheckbox.vue'
import AssignTransactionProductDialog from './assignTransactionProductDialog.vue'
import {
  getListTxnWithSubTxn,
  getTxn,
  getBusinessDistrictByTxn,
  getBusinessDistrictWithDefaultTxn,
  assignDefaultTxn,
  getBusinessShift,
  assignRoom
} from '@/api/configuration/accounting/assignBusinessDistrict'
import paginationMixin from '@/mixins/paginationMixin'

const ROOM_ASSIGN_TXN_TYPE = 2

export default {
  components: {
    Treeselect,
    CellRenderCheckbox,
    AssignTransactionProductDialog
  },
  mixins: [paginationMixin],
  data() {
    return {
      context: null,
      optionsTree: [],
      treeValue: null,

      tableLeftRows: [],
      tableLeftLoading: false,
      tableRightRows: [],
      tableRightLoading: false,
      defaultTxnRows: [],

      txnSelected: null,

      // dialog 1
      businessDistrictIds: [],

      // dialog 2
      shiftBusinessRows: [],

      shiftRows: [],
      shiftBusinessForm: {
        transaction_id: null,
        sub_transaction_id: null,
        business_district_id: null,
        shift_id: null,
        is_shift: false
      },
      defaultShiftBusinessForm: {
        transaction_id: null,
        sub_transaction_id: null,
        business_district_id: null,
        shift_id: null,
        is_shift: false
      },
      isRoomAssigned: false,
      isRoomAssignedWithShift: false,

      // dialog visibility
      dialogDefaultTxnVisible: false,
      dialogFeeVisible: false,
      dialogProductVisible: false,

      deleteDisabled: false
    }
  },

  computed: {
    shiftCols() {
      return [
        { headerName: this.$t('config.account.assign.field.id'), field: 'id' },
        {
          headerName: this.$t('config.account.assign.field.shiftName'),
          field: 'name'
        }
      ]
    },
    shiftBusinessCols() {
      return [
        {
          headerName: this.$t('config.account.assign.field.id'),
          field: 'business_district_id'
        },
        {
          headerName: this.$t(
            'config.account.assign.field.businessDistrictCode'
          ),
          field: 'business_district_code'
        },
        {
          headerName: this.$t(
            'config.account.assign.field.businessDistrictName'
          ),
          field: 'business_district_name'
        }
      ]
    },
    tableLeftColumns() {
      return [
        {
          headerName: this.$t('config.account.assign.field.txn'),
          // field: 'transaction_desc',
          width: 100,
          valueGetter: params =>
            `${params.data.transaction_id} - ${params.data.transaction_desc}`
        },
        {
          headerName: this.$t('config.account.assign.field.subTxn'),
          // field: 'sub_transaction_desc'
          valueGetter: params =>
            `${params.data.sub_transaction_id} - ${params.data.sub_transaction_desc}`
        }
      ]
    },
    tableRightColumns() {
      return [
        {
          headerName: this.$t('config.account.assign.field.business'),
          field: 'business_district_name',
          width: 100
        },
        {
          headerName: this.$t('config.account.assign.field.configTp'),
          field: 'type_name'
        },
        {
          headerName: this.$t('config.account.assign.field.shiftName'),
          field: 'shift_name'
        }
      ]
    },
    defaultTxnCols() {
      return [
        {
          // headerName: 'checkbox',
          field: 'checkboxValue',
          width: 80,
          cellRenderer: 'CellRenderCheckbox',
          cellRendererParams: params => {
            let isAssigned = false
            if (this.txnSelected) {
              isAssigned =
                params.data.default_transaction_id ===
                  this.txnSelected.transaction_id &&
                params.data.default_sub_transaction_id ===
                  this.txnSelected.sub_transaction_id
            }
            return {
              isAssigned: isAssigned
            }
          }
        },
        {
          headerName: this.$t(
            'config.account.assign.field.businessDistrictCode'
          ),
          field: 'code'
        },
        {
          headerName: this.$t(
            'config.account.assign.field.businessDistrictName'
          ),
          field: 'name'
        },
        {
          headerName: this.$t('config.account.assign.field.curTxn'),
          width: 100,
          // field: 'default_transaction_name'
          valueGetter: params =>
            `${params.data.default_transaction_id} - ${params.data.default_transaction_name}`
        },
        {
          headerName: this.$t('config.account.assign.field.curSubTxn'),
          // field: 'default_sub_transaction_name'
          valueGetter: params =>
            `${params.data.default_sub_transaction_id} - ${params.data.default_sub_transaction_name}`
        }
      ]
    }
  },

  watch: {
    async treeValue(nv, ov) {
      if (nv) {
        let paramsArray = nv.split('-')
        await this.fnGetTxn(paramsArray[0], paramsArray?.[1])
      } else {
        await this.fnGetTxn()
      }
    },
    async dialogDefaultTxnVisible(nv, ov) {
      if (!nv) {
        await this.fnGetTxn()
        this.fnGetBusinessDistrictByTxn()
      }
    },
    async dialogFeeVisible(nv, ov) {
      if (!nv) {
        await this.fnGetTxn()
        this.fnGetBusinessDistrictByTxn()
      }
    }
  },

  methods: {
    // util
    changeKeyNames(obj) {
      // Base case: if the object is not an array or an object, return it as is
      if (!obj || typeof obj !== 'object') {
        return obj
      }

      // If the object is an array, iterate over its elements
      if (Array.isArray(obj)) {
        return obj.map(item => this.changeKeyNames(item))
      }

      // If the object is an object, iterate over its key-value pairs
      const newObj = {}
      for (const key in obj) {
        // // Change the key from 'code' to 'label'
        // const newKey = key === 'code' ? 'label' : key
        // // Change the key from 'sub_transactions' to 'children'
        // const newKey1 = key === 'sub_transactions' ? 'children' : key
        // // Recursively process the value
        // newObj[newKey] = this.changeKeyNames(obj[key])
        // newObj[newKey1] = this.changeKeyNames(obj[key])
        let newKey = null
        switch (key) {
          case 'code':
            newKey = 'label'
            newObj[newKey] = this.changeKeyNames(obj[key])
            delete obj[key]
            break
          case 'sub_transactions':
            newKey = 'children'
            newObj[newKey] = this.changeKeyNames(obj[key])
            delete obj[key]
            break
          case 'id':
            newKey = 'submitId'
            newObj[newKey] = this.changeKeyNames(obj[key])
            delete obj[key]
            break
          case 'identity':
            newKey = 'id'
            newObj[newKey] = this.changeKeyNames(obj[key])
            delete obj[key]
            break
          default:
            newObj[key] = this.changeKeyNames(obj[key])
            break
        }
      }
      return newObj
    },

    // handle event
    changeCheckbox(row, value) {
      if (value) {
        this.businessDistrictIds.push(row.id)
      } else {
        this.businessDistrictIds.splice(
          this.businessDistrictIds.indexOf(row.id),
          1
        )
      }
    },

    onSelectShiftBusiness(data) {
      this.isRoomAssigned = this.isRoomAssignedWithShift = false
      this.shiftBusinessForm = { ...this.defaultShiftBusinessForm }

      this.shiftBusinessForm.business_district_id =
        data?.business_district_id || null
      if (this.shiftBusinessForm.business_district_id) {
        this.shiftRows = this.shiftBusinessRows.find(
          item =>
            this.shiftBusinessForm.business_district_id ===
            item.business_district_id
        )?.shifts
      }
      for (let item of this.tableRightRows) {
        if (
          item.business_district_id !==
          this.shiftBusinessForm.business_district_id
        ) {
          continue
        }
        if (item.type === ROOM_ASSIGN_TXN_TYPE) {
          this.isRoomAssigned = true
          if (item?.shift_id) {
            this.isRoomAssignedWithShift = true
            this.shiftBusinessForm.is_shift = true // co gan theo ca
            this.shiftBusinessForm.shift_id = item?.shift_id
          }
        }
      }
    },
    onSelectShift(data) {
      this.shiftBusinessForm.shift_id = data?.id || null
    },

    // btn
    onAssignRoom() {
      if (!this.shiftBusinessForm.business_district_id) {
        this.$message({
          type: 'error',
          message: this.$t(
            'config.account.assign.msg.businessDistrictMustBeChosen'
          )
        })
        return
      }
      this.shiftBusinessForm.transaction_id = this.txnSelected.transaction_id
      this.shiftBusinessForm.sub_transaction_id =
        this.txnSelected.sub_transaction_id

      this.fnAssignRoom()
    },

    // pagination
    async onPageChanged(pageNum) {
      this.pageParams.pageNum = pageNum
      await this.fnGetTxn()
    },
    async onPageSizeChange(pageSize) {
      this.pageParams.pageSize = pageSize
      this.pageParams.pageNum = 1
      await this.fnGetTxn()
    },

    // search
    async onSearchTxn() {
      await this.fnGetTxn()
    },

    // handle api call
    fnGetListTxnWithSubTxn() {
      getListTxnWithSubTxn()
        .then(res => {
          if (!res.is_error) {
            this.optionsTree = this.changeKeyNames(res.data)
          } else {
            throw new Error(res)
          }
        })
        .catch(error => {
          this.$message({
            message: error.response?.data?.message,
            type: 'error'
          })
        })
        .finally(() => {})
    },
    // for left table
    async fnGetTxn(txnId = null, subTxnId = null) {
      // query params
      const query = {
        // pageSize: this.pageParams.pageSize,
        // pageNum: this.pageParams.pageNum,
        transactionId: txnId,
        subTransactionId: subTxnId
      }
      try {
        let res = await getTxn(query)
        if (!res.is_error) {
          this.tableLeftRows = res.data
          // this.pageParams.totalPage = Math.ceil(
          //   res.total / this.pageParams.pageSize
          // )
        } else {
          throw new Error(res)
        }
      } catch (error) {
        this.$message({
          message: error.response?.data?.message,
          type: 'error'
        })
      }
    },
    // for right table
    fnGetBusinessDistrictByTxn(selected) {
      let query = null
      if (selected?.[0]) {
        this.tableLeftLoading = true
        this.tableRightLoading = true
        this.txnSelected = selected[0]
        query = {
          transactionId: selected[0].transaction_id,
          subTransactionId: selected[0].sub_transaction_id
        }
        getBusinessDistrictByTxn(query)
          .then(res => {
            if (!res.is_error) {
              this.tableRightRows = res.data
            } else {
              throw new Error(res)
            }
          })
          .catch(error => {
            this.$message({
              message: error.response?.data?.message,
              type: 'error'
            })
          })
          .finally(() => {
            this.tableLeftLoading = false
            this.tableRightLoading = false
          })
      }
    },

    // dialog 1
    fnGetBusinessDistrictWithDefaultTxn() {
      getBusinessDistrictWithDefaultTxn()
        .then(res => {
          if (!res.is_error) {
            this.defaultTxnRows = res.data.map(item => ({
              ...item,
              checkboxValue: false
            }))
          } else {
            throw new Error(res)
          }
        })
        .catch(error => {
          this.$message({
            message: error.response?.data?.message,
            type: 'error'
          })
        })
        .finally(() => {})
    },
    fnAssignDefaultTxn() {
      // {
      //   "transaction_id": 0,
      //   "sub_transaction_id": 0,
      //   "business_district_ids": [
      //     0
      //   ]
      // }
      let assignedBusinessDistrictIds = this.defaultTxnRows.filter(
        item =>
          item.default_transaction_id === this.txnSelected.transaction_id &&
          item.default_sub_transaction_id ===
            this.txnSelected.sub_transaction_id
      )
      let data = {
        transaction_id: this.txnSelected.transaction_id,
        sub_transaction_id: this.txnSelected.sub_transaction_id,
        business_district_ids:
          assignedBusinessDistrictIds.length > 0
            ? this.businessDistrictIds.filter(
                item => !assignedBusinessDistrictIds.some(i => i.id === item)
              )
            : this.businessDistrictIds
      }

      if (data.business_district_ids.length > 0) {
        assignDefaultTxn(data)
          .then(res => {
            if (!res.is_error) {
              this.$message({
                type: 'success',
                message: this.$t('config.account.assign.msg' + res.message) // "assignTheDefaultTransactionToTheBusinessDistrictSuccessfully."
              })
            } else {
              throw new Error(res)
            }
          })
          .catch(error => {
            this.$message({
              message: error.response?.data?.message,
              type: 'error'
            })
          })
          .finally(() => {})
      } else {
        this.$message({
          type: 'success',
          message: this.$t(
            'config.account.assign.msg.assignTheDefaultTransactionToTheBusinessDistrictSuccessfully'
          )
        })
      }
      this.defaultTxnRows = []
      this.dialogDefaultTxnVisible = false
    },

    // dialog 2
    fnGetBusinessShift() {
      getBusinessShift()
        .then(res => {
          if (!res.is_error) {
            this.shiftBusinessRows = res.data
          } else {
            throw new Error(res)
          }
        })
        .catch(error => {
          this.$message({
            message: error.response?.data?.message,
            type: 'error'
          })
        })
        .finally(() => {})
    },
    fnAssignRoom() {
      assignRoom(this.shiftBusinessForm)
        .then(res => {
          if (!res.is_error) {
            this.$message({
              type: 'success',
              message: res.message // "assignTheDefaultTransactionToTheBusinessDistrictSuccessfully"
            })
          } else {
            throw new Error(res)
          }
        })
        .catch(error => {
          this.$message({
            message: error.response?.data?.message, // shiftHasBeenConfigured
            type: 'error'
          })
        })
        .finally(() => {
          this.shiftBusinessForm = { ...this.defaultShiftBusinessForm }
          this.dialogFeeVisible = false
        })
    },

    // delete
    async fnDeleteConfig() {
      const gridApi = this.$refs.agGridRight.gridApi
      const rowsSelected = gridApi.getSelectedRows()
      const id_list = rowsSelected.map(item => item.id)
      if (id_list.length == 0) {
        this.$alert('Bạn chưa chọn cấu hình của khu kinh doanh!', 'Error', {
          confirmButtonText: 'OK'
        })
      } else {
        this.$vxConfirm(
          this.$t('config.account.assign.msg.configDelete'),
          () => {
            this.$axios
              .delete('/config-service/v1/assign-business-district/', {
                data: {
                  id_list: id_list
                }
              })
              .then(res => {
                if (!res.is_error) {
                  this.$message({
                    message: res.message,
                    type: 'success'
                  })

                  this.onReset()
                } else {
                  throw new Error(res)
                }
              })
              .catch(error => {
                this.$message({
                  message: error.response?.data?.message, // defaultConfigurationCannotBeDeleted
                  type: 'error'
                })
              })
              .finally(() => {})
          }
        )
      }
    },

    onSelectRow() {
      const gridApi = this.$refs.agGridRight.gridApi
      const rowsSelected = gridApi.getSelectedRows()
      const id_list = rowsSelected.map(item => item.id)
      if (id_list.length == 0) {
        this.deleteDisabled = true
      } else {
        this.deleteDisabled = false
      }
    },

    // reset search
    async onReset() {
      this.fnGetListTxnWithSubTxn()
      await this.fnGetTxn()
      this.fnGetBusinessDistrictByTxn()
      this.fnGetBusinessDistrictWithDefaultTxn()
      this.fnGetBusinessShift()
    }
  },

  beforeMount() {
    this.context = { componentParent: this }
  },

  async mounted() {
    this.fnGetListTxnWithSubTxn()
    await this.fnGetTxn()
    this.fnGetBusinessDistrictByTxn()
    this.fnGetBusinessDistrictWithDefaultTxn()
    this.fnGetBusinessShift()
  }
}
</script>

<style lang="scss" scoped>
.datnt {
  display: flex;
  &::before {
    content: '';
    width: 1px;
    height: 100%;
    background-color: #dcdfe6;
    display: inline-block;
    margin-right: 20px;
  }
  div {
    flex-grow: 1;
  }
}
</style>
